/* eslint-disable @typescript-eslint/no-explicit-any, camelcase */

/**
 * This file is autogenerated, please don't edit it manually.
 * Use this command to regenerate it if you modified Epic experiments:
 * yarn epic:types
 */

/**
 * Epic experiments namespaces with their possible keys.
 * Autogenerated from static/bundles/epic/data/defaults/
 */
import client from 'bundles/epic/client';
import Authoring from 'bundles/epic/data/defaults/Authoring.json';
import type { Tags } from 'bundles/epic/lib/EpicTypes';

type Namespace = {
  enabledItemSharingTypes: any;
  experimentalItemSharingTypes: [] | ['discussionPrompt', 'gradedDiscussionPrompt', 'ungradedWidget'];
  enablePluginUpdatedUi: boolean;
  enableV2PluginItemAuthoring: boolean;
  enableCourseOutlineSummaryExports: boolean;
  enableCoachForAuthors: boolean;
  enableCommonCartridgeSmartIngestion: boolean;
  enableCommonCartridgeSmartIngestionLaunch: boolean;
  enableDescriptIntegration: boolean;
  enableCourseBuilderNonEnglishSupport: boolean;
  enableDescriptIntegrationByPartnerId: boolean;
  enableGraphQlCreateAuthoringAssetCreationAttempt: boolean;
  enableCoachForSmartIngestion: boolean;
  enableGradedPlugin: boolean;
  enableCbVerifiedSkills: boolean;
  enableCbVerifiedSkillsP0ByPartnerId: boolean;
  enableCbVerifiedSkillsP1ByPartnerId: boolean;
  enableAdVideoAuthoring: boolean;
};

const NAMESPACE = 'Authoring';

// Adding safe optional chaining to avoid massive changes in unit tests.
client.addDefaults?.([Authoring as $TSFixMe]);

const AuthoringEpicClient = {
  get<K extends keyof Namespace>(key: K, tags?: Tags): Namespace[K] {
    return client.get(NAMESPACE, key, tags);
  },

  preview<K extends keyof Namespace>(key: K, tags?: Tags, defaults?: Namespace): Namespace[K] {
    return client.preview(NAMESPACE, key, tags);
  },
};

export default AuthoringEpicClient;
